import React, { useEffect, useState } from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../UI/Media';
import '../../Banners/hero.css';
import '../../Banners/RightText/imageRightTextBanner.css';
import './colorama.css';
import { Grid } from '../../../UI/Grid/grid';
import { useMediaQuery } from '../../../../utils/hooks/useMediaQuery';
import { BannerButtons } from '../../Banners';

const letters = [
  { text: 'C', color: '#FFC33B' },
  {
    text: 'o',
    color: '#FF7A37',
  },
  { text: 'l', color: '#FF7B7D' },
  { text: 'o', color: '#EE264B' },
  { text: 'r', color: '#7A6096' },
  { text: 'a', color: '#324B83' },
  { text: 'm', color: '#0598F3' },
  { text: 'a', color: '#8DC040' },
  { text: '!', color: '#0E712A' },
];

export const ColoramaTitle = (props) => {
  const [activeLetter, setActiveLetter] = useState(-1);

  useEffect((): void => {
    let timer;
    setTimeout(() => {
      timer = setInterval(() => {
        setActiveLetter((prevTime) => {
          if (prevTime + 1 > letters.length + 24) {
            return 0;
          } else return prevTime + 1;
        });
      }, 125);
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <p className='font-monument text-4xl lg:text-6xl font-bold text-white'>
      {letters.map((letter, index) => (
        <span
          style={{
            color: activeLetter === index && letter.color,
          }}>
          {letter.text}
        </span>
      ))}
    </p>
  );
};

export const ImageRightTextBannerColorama = ({
  label,
  body,
  image,
  desktopImage,
  badges,
  buttons,
  placement = 'right',
}) => {
  const isWindowSmallSize = useMediaQuery('lg');
  const itemsAlign = placement === 'center' ? 'center' : 'start';
  const textAlign = placement === 'center' ? 'center' : 'left';
  const bottomBorderRadius = isWindowSmallSize
    ? '0px 0px 75px 75px'
    : '0px 0px 150px 150px';

  return (
    <>
      <div className='w-screen hero-main relative flex justify-center'>
        <div
          className='absolute md:hidden h-full overflow-hidden w-full'
          style={{
            borderRadius: bottomBorderRadius,
            boxShadow: '0 0 0 10px hsl(0, 0%, 100%),0 0 0 12px #FEAE00',
          }}>
          {image && (
            <Image
              objectFit='cover'
              {...image}
              height='100%'
              width='100%'
            />
          )}
        </div>
        <div
          className='hidden absolute md:block overflow-hidden h-full w-full'
          style={{
            borderRadius: bottomBorderRadius,
            boxShadow: '0 0 0 10px hsl(0, 0%, 100%),0 0 0 12px #FEAE00',
          }}>
          {desktopImage && (
            <Image
              objectFit='cover'
              {...desktopImage}
              height='100%'
              width='100%'
            />
          )}
        </div>
        <div
          id='hero-main'
          className='hero-main flex flex-col-reverse md:flex-row w-full min-h-full justify-center items-center relative'>
          <div className='main-wrapper items-center absolute top-0 lg:relative flex w-full h-full'>
            {(placement === 'right' || placement === 'center') && (
              <div className='flex-1 hidden lg:block' />
            )}
            <div className='h-3/4 lg:h-2/3 flex-1 flex justify-between lg:justify-center flex-col'>
              <div
                className={`flex items-${itemsAlign} text-${textAlign} justify-center flex-col`}>
                <div className='mb-4 flex w-11/12'>
                  {badges?.items.map((badge) => (
                    <div className='mr-2'>
                      <Badge {...badge} />
                    </div>
                  ))}
                </div>
                <div className='mb-4 w-11/12'>
                  <Label
                    {...label}
                    family='font-gilmer'
                    size='base'
                    weight='bold'
                    transform='uppercase'
                    color={{ classname: 'white' }}
                  />
                </div>
                <div className='mb-4 w-11/12'>
                  <ColoramaTitle />
                </div>
                <div className='mb-6'>
                  <Label
                    {...body}
                    family='font-inter'
                    size='xl'
                    color={{ classname: 'white' }}
                  />
                </div>
                <BannerButtons
                  buttons={buttons}
                  size='lg'
                />
              </div>
            </div>
            {(placement === 'left' || placement === 'center') && (
              <div className='flex-1 hidden lg:block' />
            )}
          </div>
        </div>
      </div>
      <div className='h-8 py-12 flex'>
        {letters.map((letter) => (
          <div
            className='w-4 h-4 rounded-full mx-1'
            style={{ background: letter.color }}
          />
        ))}
      </div>
    </>
  );
};

export const ColoramaProductColorHighlight = ({
  grid,
  label,
  subLabel,
  image,
  imageFirst = { value: true },
}) => (
  <div
    className={`w-full h-full flex flex-col ${
      !imageFirst.value ? 'lg:flex-row-reverse' : 'lg:flex-row'
    }`}>
    <div className='w-full lg:w-2/5 h-auto cursor-pointer overflow-hidden rounded-full colorama-hightlight-image transition duration-100'>
      <div className='h-full cursor-pointer'>
        <Image
          {...image}
          height='100%'
        />
      </div>
    </div>
    <div className='flex relative flex-col h-auto justify-center w-full py-5 lg:py-0 lg:w-3/5 lg:px-16'>
      <Label
        {...label}
        size='4xl'
        weight='bold'
      />
      <div className='mt-4'>
        <Label {...subLabel} />
      </div>
      <div className='mt-12 border-t border-b lg:border-none'>
        <Grid
          grid={{
            ...grid,
            wrap: true,
            isSlider: 'block lg:hidden',
            itemsWidth:
              'min-w-10/12 md:w-1/2 md:min-w-5/12 xl:w-1/4 xl:min-w-1/4',
          }}
        />
      </div>
    </div>
  </div>
);

export const ColoramaImageLeftTextFaceHighLightBanner = ({
  label,
  body,
  desktopImage,
  buttons,
}: BannerProps) => {
  const isWindowSmall = useMediaQuery('sm');
  return (
    <div
      style={{
        background:
          'linear-gradient(90deg, rgba(250,145,126,1) 0%, rgba(222,191,207,1) 100%)',
      }}
      id='image-left-text-face-highlight-hero'
      className='overflow-hidden border-t border-b w-screen relative flex justify-center items-start flex-col lg:h-128 lg:flex-row lg:py-10'>
      {/* Mobile Image */}
      <div className='lg:hidden h-full w-full'>
        <Image
          {...desktopImage}
          isNative
          objectFit='cover'
          width='100%'
          height='100%'
        />
      </div>
      {/* Desktop & Tablet Image */}
      <div className='hidden absolute top-0 lg:flex justify-end h-full w-screen'>
        <div className='flex justify-end w-auto h-full'>
          <Image
            {...desktopImage}
            isNative
            height='100%'
          />
        </div>
      </div>
      {/* Text Label */}
      <div className='main-wrapper h-full items-start flex w-full'>
        <div
          className={`flex-1 border-t h-full border-${
            label.color?.classname || 'white'
          } relative flex items-center justify-start`}>
          <div className='flex flex-col pt-6 lg:w-7/12'>
            <Label
              {...label}
              size={isWindowSmall ? '5xl' : '7xl'}
              weight='medium'
              color={label.color || { classname: 'white' }}
            />
            <div className='pl-0 lg:pl-10 mt-8 mb-6'>
              <div className='mb-8'>
                <Label
                  {...body}
                  size='xl'
                  color={{ classname: 'white' }}
                />
              </div>
              <div className='w-full mt-4 flex justify-start'>
                <BannerButtons
                  buttons={buttons}
                  size='lg'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
